import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

import { Globals } from './../global';
import { map, catchError } from 'rxjs/operators';
import { EventsService } from './events.service';
import { throwError, BehaviorSubject } from 'rxjs';
import { BehSubjectService } from './beh-subject.service';


@Injectable()
export class GameService {

  public mainLoader = new BehaviorSubject<boolean>(false);

  constructor(
    private http: HttpClient,
    private global: Globals,
    private events: EventsService,
    private beh: BehSubjectService
  ) {
    // console.debug(this.global.getHeaders(true).lazyUpdate)
  }

  getGame() {
    const requestHeader = this.global.getHeaders();
    const requestEndpoint = 'game';

    this.events.eventStart({ eventType: 'API_CALL', requestData: JSON.stringify({ header: requestHeader.lazyUpdate, body: null, endpoint: requestEndpoint }) })
    this.beh.apiRequest$.next(JSON.stringify({ header: requestHeader, body: null }));

    return this.http.get(`${this.global.baseUrl}${requestEndpoint}`, { headers: requestHeader }).pipe(map((response) => {
      this.events.eventStart({
        eventType: 'API_CALL_SUCCESS',
        requestData: JSON.stringify({ header: requestHeader.lazyUpdate, body: null, endpoint: requestEndpoint }),
        responseData: JSON.stringify(response)
      });

      return response;
    }, catchError(this.handleError)));
  }

  gameStart() {
    const requestHeader = this.global.getHeaders(true);
    const requestBody = {};
    const requestEndpoint = `game/start`;

    this.events.eventStart({ eventType: 'API_CALL', requestData: JSON.stringify({ header: requestHeader.lazyUpdate, body: requestBody, endpoint: requestEndpoint }) })
    this.beh.apiRequest$.next(JSON.stringify({ header: requestHeader, body: null }));

    return this.http.post(`${this.global.baseUrl}${requestEndpoint}`, requestBody, { headers: requestHeader }).pipe(map((response) => {
      this.events.eventStart({
        eventType: 'API_CALL_SUCCESS',
        requestData: JSON.stringify({ header: requestHeader.lazyUpdate, body: requestBody, endpoint: requestEndpoint }),
        responseData: JSON.stringify(response)
      });

      return response;
    }, catchError(this.handleError)));
  }

  gameFinish() {
    const requestHeader = this.global.getHeaders(true);
    const requestBody = {};
    const requestEndpoint = `game/finish`;

    this.events.eventStart({ eventType: 'API_CALL', requestData: JSON.stringify({ header: requestHeader.lazyUpdate, body: requestBody, endpoint: requestEndpoint }) })
    this.beh.apiRequest$.next(JSON.stringify({ header: requestHeader, body: null }));

    return this.http.post(`${this.global.baseUrl}${requestEndpoint}`, requestBody, { headers: requestHeader }).pipe(map((response) => {
      this.events.eventStart({
        eventType: 'API_CALL_SUCCESS',
        requestData: JSON.stringify({ header: requestHeader.lazyUpdate, body: requestBody, endpoint: requestEndpoint }),
        responseData: JSON.stringify(response)
      });

      return response;
    }, catchError(this.handleError)));
  }

  getQuestion() {
    const requestHeader = this.global.getHeaders(true);
    const requestEndpoint = `game/question`;

    this.events.eventStart({ eventType: 'API_CALL', requestData: JSON.stringify({ header: requestHeader.lazyUpdate, body: null, endpoint: requestEndpoint }) })
    this.beh.apiRequest$.next(JSON.stringify({ header: requestHeader, body: null }));

    return this.http.get(`${this.global.baseUrl}${requestEndpoint}`, { headers: requestHeader }).pipe(map((response) => {
      this.events.eventStart({
        eventType: 'API_CALL_SUCCESS',
        requestData: JSON.stringify({ header: requestHeader.lazyUpdate, body: null, endpoint: requestEndpoint }),
        responseData: JSON.stringify(response)
      });

      return response;
    }, catchError(this.handleError)));
  }

  getCorrectAnswer(answerIndex, moveId, time, help = null, optional = null) {
    const requestHeader = this.global.getHeaders(true);
    const requestBody = { index: answerIndex, moveId: moveId, time: time, help: help, optional: optional };
    const requestEndpoint = 'game/answer';

    this.events.eventStart({ eventType: 'API_CALL', requestData: JSON.stringify({ header: requestHeader.lazyUpdate, body: requestBody, endpoint: requestEndpoint }) })
    this.beh.apiRequest$.next(JSON.stringify({ header: requestHeader, body: null }));

    return this.http.post(`${this.global.baseUrl}${requestEndpoint}`, requestBody, { headers: requestHeader }).pipe(map((response) => {
      this.events.eventStart({
        eventType: 'API_CALL_SUCCESS',
        requestData: JSON.stringify({ header: requestHeader.lazyUpdate, body: requestBody, endpoint: requestEndpoint }),
        responseData: JSON.stringify(response)
      });

      return response;
    }, catchError(this.handleError)));
  }

  getHelpOK(searchKey) {
    const requestHeader = this.global.getHeaders(true);
    const requestBody = {};
    const requestEndpoint = `game/help/${searchKey}`;

    this.events.eventStart({ eventType: 'API_CALL', requestData: JSON.stringify({ header: requestHeader.lazyUpdate, body: requestBody, endpoint: requestEndpoint }) })
    this.beh.apiRequest$.next(JSON.stringify({ header: requestHeader, body: null }));

    return this.http.post(`${this.global.baseUrl}${requestEndpoint}`, requestBody, { headers: requestHeader }).pipe(map((response) => {
      this.events.eventStart({
        eventType: 'API_CALL_SUCCESS',
        requestData: JSON.stringify({ header: requestHeader.lazyUpdate, body: requestBody, endpoint: requestEndpoint }),
        responseData: JSON.stringify(response)
      });

      return response;
    }, catchError(this.handleError)));
  }

  getPlayerData() {
    const requestHeader = this.global.getHeaders(true);
    const requestEndpoint = 'player/';

    this.events.eventStart({ eventType: 'API_CALL', requestData: JSON.stringify({ header: requestHeader.lazyUpdate, body: null, endpoint: requestEndpoint }) })
    this.beh.apiRequest$.next(JSON.stringify({ header: requestHeader, body: null }));

    return this.http.get(`${this.global.baseUrl}${requestEndpoint}`, { headers: requestHeader }).pipe(map((response) => {
      this.events.eventStart({
        eventType: 'API_CALL_SUCCESS',
        requestData: JSON.stringify({ header: requestHeader.lazyUpdate, body: null, endpoint: requestEndpoint }),
        responseData: JSON.stringify(response)
      });

      return response;
    }, catchError(this.handleError)));
  }

  createPlayerData() {
    const requestHeader = this.global.getHeaders();
    const requestBody = {};
    const requestEndpoint = 'player/guest';

    this.events.eventStart({ eventType: 'API_CALL', requestData: JSON.stringify({ header: requestHeader.lazyUpdate, body: requestBody, endpoint: requestEndpoint }) })
    this.beh.apiRequest$.next(JSON.stringify({ header: requestHeader, body: null }));

    this.http.post(`${this.global.baseUrl}${requestEndpoint}`, requestBody, { headers: requestHeader }).subscribe(data => {
      this.events.eventStart({
        eventType: 'API_CALL_SUCCESS',
        requestData: JSON.stringify({ header: requestHeader.lazyUpdate, body: null, endpoint: requestEndpoint }),
        responseData: JSON.stringify(data)
      });

      if (data['responseCode'] < 400) {
        localStorage.setItem('token', data['responseData'].token);
        return true;
      }
    }, nodata => {
      this.events.eventStart({ eventType: 'API_CALL_ERROR', responseData: JSON.stringify(nodata) });
    });
  }

  getAvailablePacks() {
    const requestHeader = this.global.getHeaders(true);
    const requestEndpoint = `wallet/pack`;

    this.events.eventStart({ eventType: 'API_CALL', requestData: JSON.stringify({ header: requestHeader.lazyUpdate, body: null, endpoint: requestEndpoint }) })
    this.beh.apiRequest$.next(JSON.stringify({ header: requestHeader, body: null }));

    return this.http.get(`${this.global.baseUrl}${requestEndpoint}`, { headers: requestHeader }).pipe(map((response) => {
      this.events.eventStart({
        eventType: 'API_CALL_SUCCESS',
        requestData: JSON.stringify({ header: requestHeader.lazyUpdate, body: null, endpoint: requestEndpoint }),
        responseData: JSON.stringify(response)
      });

      return response;
    }, catchError(this.handleError)));
  }

  redeemPack(searchKey) {
    const requestHeader = this.global.getHeaders(true);
    const requestBody = {};
    const requestEndpoint = `wallet/pack/${searchKey}`;

    this.events.eventStart({ eventType: 'API_CALL', requestData: JSON.stringify({ header: requestHeader.lazyUpdate, body: requestBody, endpoint: requestEndpoint }) })
    this.beh.apiRequest$.next(JSON.stringify({ header: requestHeader, body: null }));

    return this.http.post(`${this.global.baseUrl}${requestEndpoint}`, requestBody, { headers: requestHeader }).pipe(map((response) => {
      this.events.eventStart({
        eventType: 'API_CALL_SUCCESS',
        requestData: JSON.stringify({ header: requestHeader.lazyUpdate, body: requestBody, endpoint: requestEndpoint }),
        responseData: JSON.stringify(response)
      });

      return response;
    }, catchError(this.handleError)));
  }

  private handleError(error: HttpErrorResponse) {
    this.events.eventStart({ eventType: 'API_CALL_ERROR', responseData: 'Backend call failed' });
    return throwError('Something bad happened, please try again later.');
  }
}
